import React, { useState } from 'react'

import { controlBarGestureEventEmitter, gestureKeys } from 'helpers/events'

import * as Styles from './styles'

export default function Toast() {
    const [text, setText] = useState('')

    React.useEffect(() => {
        const handleAcknowledgement = () => {
            const handleAcknowledgementToast = document.getElementById(
                'toast-mobile'
            )
            if (handleAcknowledgementToast) {
                setText('Teacher Acknowledged')
                handleAcknowledgementToast.style.setProperty('display', 'flex')
                setTimeout(() => {
                    handleAcknowledgementToast.style.setProperty(
                        'display',
                        'none'
                    )
                    setText('')
                }, [3000])
            }
        }

        controlBarGestureEventEmitter.addListener(
            gestureKeys.TEACHER_ACKNOWLEDGEMENT,
            handleAcknowledgement
        )

        return () => {
            controlBarGestureEventEmitter.removeListener(
                gestureKeys.TEACHER_ACKNOWLEDGEMENT,
                handleAcknowledgement
            )
        }
    }, [])

    return (
        <Styles.Wrapper id="toast-mobile">
            <Styles.Container>
                <img src="assets/tick.svg" />
                <Styles.Info>{text}</Styles.Info>
            </Styles.Container>
        </Styles.Wrapper>
    )
}
